import { Injectable } from '@angular/core';
import { TableDataApiParams } from '@services/practices.service';
import { DataSourceBaseNew } from '@components/new-table/data-source-base-new.dataSource';
import { TablePracticeModel } from '@/models/tables/table-practices.model';
import { BusinessMachinesService } from '@services/business-machines.service';

@Injectable({
  providedIn: 'root',
})
export class BusinessMachinesDataSource extends DataSourceBaseNew<TablePracticeModel> {
  constructor(private businessMachinesService: BusinessMachinesService) {
    super();
  }

  loadData(params?: TableDataApiParams): void {
    this._isLoading$.next(true);
    this.businessMachinesService.getDataForTable(params).subscribe((data) => {
      this.elements$.next(data.content);
      this._totalElements$.next(data.totalElements);
      this._isLoading$.next(false);
    });
  }
}
